import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsDashboardsListEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(() =>
		import(/* webpackChunkName: "async-assets-dashboards-list-entrypoint" */ './index.tsx').then(
			(module) => module.AssetsDashboardsList,
		),
	),
	getPreloadProps: () => ({}),
});
